import { FC } from "react";
import styled from "@emotion/styled";
import { MDSSkeleton } from "@/mds/components/loading/skeleton";

export const IntegrationsPageSkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <ContentSkeleton>
        <SectionSkeleton>
          <MDSSkeleton height={16} width={220} />
          <BlockSkeleton>
            <MDSSkeleton height={100} width={320} />
          </BlockSkeleton>
        </SectionSkeleton>
        <SectionSkeleton>
          <MDSSkeleton height={16} width={220} />
          <BlockSkeleton>
            <MDSSkeleton height={100} width={320} />
            <MDSSkeleton height={100} width={320} />
          </BlockSkeleton>
        </SectionSkeleton>
      </ContentSkeleton>
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  padding: "16px",
});

const ContentSkeleton = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
});

const SectionSkeleton = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  alignItems: "flex-start",
});

const BlockSkeleton = styled.div({
  display: "flex",
  flexDirection: "row",
  gap: "16px",
});
